import { createRemoteComponent } from '@remote-ui/core';

/**
 * Image is used for large format, responsive images.
 */
const Image = createRemoteComponent('Image');

export { Image };
